import React from 'react';
import {
  BgColorsOutlined,
  CheckOutlined,
  MoonOutlined,
} from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useTheme } from '../../theme/ThemeProvider';
import { THEME_OPTIONS, ThemeMode } from '../../theme/theme';

type ThemeToggleProps = {
  className?: string;
};

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();
  const selectedTheme =
    THEME_OPTIONS.find((option) => option.id === theme) || THEME_OPTIONS[0];

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      menu={{
        selectable: true,
        selectedKeys: [theme],
        onClick: ({ key }) => setTheme(key as ThemeMode),
        items: THEME_OPTIONS.map((option) => ({
          key: option.id,
          label: (
            <span className="theme-menu-option">
              <span
                className="theme-menu-option__swatch"
                style={{ background: option.color }}
                aria-hidden
              />
              <span>{option.label}</span>
              {theme === option.id ? (
                <CheckOutlined className="theme-menu-option__check" />
              ) : null}
            </span>
          ),
        })),
      }}
    >
      <button
        type="button"
        className={`theme-toggle ${className}`.trim()}
        aria-label={`Choose color theme. Current theme: ${selectedTheme.label}`}
        title={`Theme: ${selectedTheme.label}`}
      >
        {selectedTheme.dark ? <MoonOutlined /> : <BgColorsOutlined />}
        <span
          className="theme-toggle__swatch"
          style={{ background: selectedTheme.color }}
          aria-hidden
        />
      </button>
    </Dropdown>
  );
};

export default ThemeToggle;
